export default __webpack_public_path__ + "static/img_1-7f80dac78669b0640e53dddb102dec98.png";